<div class="container cpal">
  <div class="row">
    <h2>Mi Perfil</h2>
  </div>
  <div class="row">
    <div class="col-md-1 mt-5"></div>
    <div class="col-md-3 mt-5">
      <img class="img-fluid fperfil" src="assets/img/foto perfil.jpg" alt="">
    </div>
    <div class="col-md-7">
      <form [formGroup]="perfilForm" (ngSubmit)="submitForm()" class="mt-5">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="w-100" disabled>
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required placeholder="email" readonly>
          <mat-error *ngIf="perfilForm.get('email')?.hasError('required')">El email es obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="w-100">
          <mat-label>RUT</mat-label>
          <input matInput formControlName="rut" required placeholder="XXXXXXXX-X">
          <mat-error *ngIf="perfilForm.get('rut')?.hasError('required')">El RUT es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="nombre" required placeholder="Nombre">
          <mat-error *ngIf="perfilForm.get('nombre')?.hasError('required')">El nombre es obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Apellido Paterno</mat-label>
          <input matInput formControlName="apellidoPaterno" required placeholder="Apellido Paterno">
          <mat-error *ngIf="perfilForm.get('apellidoPaterno')?.hasError('required')">El apellido paterno es obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Apellido Materno</mat-label>
          <input matInput formControlName="apellidoMaterno" required placeholder="Apellido Materno">
          <mat-error *ngIf="perfilForm.get('apellidoMaterno')?.hasError('required')">El apellido materno es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="fr mt-4">
      <button mat-raised-button color="primary" type="submit">Enviar</button>
    </div>
      </form>
    </div>
  </div>
</div>